import React from 'react';
import Screen from '../../components/common/Screen';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Image from '../../components/images/Image';

// Post-registration thank-you page for delaware Sporty B1 — now closed.
// Kept on this route so old confirmation links don't 404; the body is
// replaced with a polite "no longer available" notice.
const DelawareRegistrationThankYou = () => {
  const backgroundPicture = localStorage.getItem('backgroundPicture');

  return (
    <Screen
      backgroundImage={
        backgroundPicture?.includes('http')
          ? backgroundPicture
          : require('./../../assets/images/sporty_B1_hercules_trophy_edition-registration_page.jpg')
      }
    >
      <div className="center" style={{ width: '100%' }}>
        <Card style={{ width: 'min(30rem, calc(100% - 2rem))', opacity: '0.96' }} mx="0">
          <Title my="0" className="mb-3">Registration is closed</Title>
          <p className="mb-3">
            The Sporty B1 – Hercules Trophy Edition registration is no longer accepting submissions.
          </p>
          <p className="mb-1">Sporty regards,</p>
          <p className="mb-0"><strong>The delaware Event Team</strong></p>
        </Card>
      </div>

      <div className="bottom" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '-1rem' }}>
        <Card style={{ opacity: '0.8' }} p="0">
          <Image
            url={require('./../../assets/images/logo_text.png')}
            to="https://tornea.net"
            className="mx-5"
            isSquare={false}
            style={{ width: '8rem', height: '4rem' }}
          />
        </Card>
      </div>
    </Screen>
  );
};

export default DelawareRegistrationThankYou;
